(() => {
  // source/product-description.js
  customElements.define("product-description-component", class ProductDescription extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", (event) => {
        const heading = event.target.closest?.(".tab-content--heading");
        if (heading && this.toggleTab(heading)) event.preventDefault();
      });
    }
    toggleTab(heading) {
      if (!heading?.matches(".tab-content--heading") || heading.closest("product-description-component") !== this) return false;
      const panelId = heading.getAttribute("aria-controls") || heading.getAttribute("aria-control")?.replace(/^#/, "");
      const panels = Array.from(this.querySelectorAll(".tab-content--body[id]")).filter((panel) => panel.closest("product-description-component") === this);
      const selectedPanel = panelId && panels.find((panel) => panel.id === panelId);
      if (!selectedPanel) return false;
      this.querySelectorAll(".tab-content--heading").forEach((item) => {
        if (item.closest("product-description-component") === this) {
          item.classList.toggle("active", item === heading);
        }
      });
      panels.forEach((panel) => panel.classList.toggle("active", panel === selectedPanel));
      return true;
    }
  });
})();
